import { createContext, useState, useEffect } from 'react';

const NavigationContext = createContext();
// The params of the matched `Route` template, e.g. { accountId } for /sync/:accountId.
const RouteParamsContext = createContext({});

function NavigationProvider({ children }) {
    const [currentPath, setCurrentPath] = useState(window.location.pathname);
    // The state of the current history entry: what one screen hands to the next (a toast, a banner).
    const [locationState, setLocationState] = useState(window.history.state ?? null);

    useEffect(() => {
        const handler = (event) => {
            setCurrentPath(window.location.pathname);
            setLocationState(event.state ?? null);
        }
        window.addEventListener('popstate', handler);

        return () => {
            window.removeEventListener('popstate', handler);
        };

    }, [])

    const navigate = (to, { replace = false, state = null } = {}) => {
        if (replace) {
            window.history.replaceState(state, '', to);
        } else {
            window.history.pushState(state, '', to);
        }
        setCurrentPath(to);
        setLocationState(state);
    }

    // A handed-over toast or banner is shown once: drop it so Back or a reload does not show it again.
    const clearLocationState = () => {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
        setLocationState(null);
    }

    return (
        <NavigationContext.Provider value={{currentPath, navigate, locationState, clearLocationState}}>
            {children}
        </NavigationContext.Provider>
    )
}

export { NavigationProvider, RouteParamsContext };
export default NavigationContext;
